<template>
  <div>



    <div class="page-picker-wrapper">
      <div class="page-header">
        <span style="float: left;font-size: large;font-weight: bolder;">归属地</span>
        <span @click="closeP" style="float: right">X</span>
        <div style="clear: both;margin-bottom: 4%"></div>
        <div class="title-add">
          <div style="width: 25%;float: left">
            <div>
              <span id="pN" class="cont" @click="sProvince()">{{selectP}} </span>
            </div>
          </div>
          <div style="float: left;width: 25%"  v-show="hflag">
            <div>
              <span id="cN" class="cont" @click="sCity">{{selectC}} </span>
            </div>
          </div>
          <div style="clear: both;margin-bottom: 4%"></div>
        </div>
      </div>
      <div class="radio">
        <div
          style="color: red;height: 10px;font-size:14px;font-weight: lighter;">
        </div>
        <div class="flow">
          <div style="height: 40px; margin-left: 10px;" v-for="item in  provinces"
               @click="queryProvince(item.province_code,item.province_name)">
            <input type="radio" readonly="readonly" class="mint-radio-input"
                   v-model="provinceName"
                   v-bind:value="item.province_name">
            <span class="mint-radio-name">{{item.province_name}}</span>
          </div>

          <div style="height: 40px; margin-left: 10px;" v-for="item in  citys"
               @click="queryCity(item.local_net,item.city_name)">
            <input type="radio" readonly="readonly" class="mint-radio-input"
                   v-model="cityName"
                   v-bind:value="item.city_name">
            <span class="mint-radio-name">{{item.city_name}}</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'Address',
    data() {
      return {
        message: '',
        selectP: '请选择',
        selectC: '请选择',
        wxzLocal: 'wxzLocal',
        xzLocal: 'xzLocal',
        provinceName: '',
        provinceCode: '',
        cityName: '',
        provinces: {},
        citys: {},
        showN: false,
        hflag: false,
        xhP: false,
        xhC: false,
        popupVisible: false,
      };
    },
    created() {
    },
    methods: {

      sCity() {
        let params = {provinceCode: this.provinceCode};
        // console.log('--provinceName--' + value);
        this.axios.post(this.headUrl + 'queryProvince', params).then(res => res.data).then(data => {
          data = JSON.parse(data);
          console.log(data);
          if (data.resCode === '1') {
            this.provinces = {};
            this.citys = data.citys;
          } else {
            this.provinceName = this.selectP;
            this.popupVisible = false;
            sessionStorage.setItem('provinceName', this.provinceName);
          }
        });
      },
      queryCity(item, value) {
        this.selectC = value;
        this.localNet = item;
        this.popupVisible = false;
        this.provinceName = this.selectP;
        this.cityName = this.selectC;
        // this.searchNum();
        this.xhP = false;
        this.xhC = this;
        sessionStorage.setItem('localNet', this.localNet);
        sessionStorage.setItem('provinceName', this.provinceName);
        sessionStorage.setItem('cityName', this.cityName);
        this.selectNum();
        // this.queryAll();
        // document.getElementById(item).style.color = '#ef4f4f';
      },
      sProvince() {
        // this.selectP = '请选择';
        let params = {provinceCode: ''};
        this.axios.post(this.headUrl + 'queryProvince', params).then(res => res.data).then(data => {
          data = JSON.parse(data);
          if (data.resCode === '1') {
            this.provinces = data.provinces;
            this.citys = {};
          } else {
            this.popupVisible = false;
          }
        });
      },
      queryProvince(item, value) {
        this.provinceCode = item;
        this.selectP = value;
        this.xhP = true;
        this.xhC = false;
        this.provinces = {};
        this.isLocal = false;
        this.selectC = '请选择';
        this.hflag = true;
        this.sCity();
        // document.getElementById(item).style.color = '#ef4f4f';
      },
      closeP() {
        this.popupVisible = false;
      }
    }
  };
</script>

<style scoped>

  .flow {
    color: black;
    width: 50%;
    z-index: 920;
    position: absolute;
    height: 80%;
    overflow-y: auto;
    /*background-color: #ef4f4f;*/
  }

  .page-picker-wrapper {
    height: 100%;
    padding: 10px 4% 0px 4%;

  }
</style>



// WEBPACK FOOTER //
// src/components/address/address.vue